import React, { useState } from 'react';
import { CFormLabel, CFormSwitch, CPopover, CSpinner } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SimpleSwitchGroup = ({ id, name, label, checked, className, data, setFieldValue, disabled, onChangeCustom, statusLoading, tooltip }) => {
     const [status, setStatus] = useState(checked);

     const onChange = (e) => {
          if (disabled) return;

          if (onChangeCustom) {
               onChangeCustom(e, setStatus);
               return;
          }

          if (data) {
               const dataStatus = data.filter((filterData) => filterData.status === !status)[0];

               setFieldValue(name, dataStatus.id);
          } else {
               setFieldValue(name, !status);
          }

          setStatus(!status);
     };

     return (
          <div
               className={classNames('form-group-switch d-flex justify-content-start align-items-center', {
                    [className]: className,
                    disabled,
               })}
          >
               <CFormLabel htmlFor={id} className="mb-0 me-3">
                    {label}
                    {tooltip && (
                         <CPopover content={tooltip} placement="top" trigger="hover">
                              <CIcon icon="icon-info-cilcle" />
                         </CPopover>
                    )}
               </CFormLabel>
               <CFormSwitch name={name} size="xl" id={id} checked={checked} onChange={onChange} disabled={disabled || statusLoading} />
               {statusLoading && <CSpinner color="primary" size="sm" />}
          </div>
     );
};

SimpleSwitchGroup.propTypes = {
     id: PropTypes.string,
     name: PropTypes.string,
     label: PropTypes.string,
     checked: PropTypes.bool,
     setFieldValue: PropTypes.func,
     disabled: PropTypes.bool,
     onChangeCustom: PropTypes.func,
     statusLoading: PropTypes.bool,
     tooltip: PropTypes.string,
};

SimpleSwitchGroup.defaultProps = {
     checked: true,
};

export default SimpleSwitchGroup;
